// Auto-generated normalizer for table: CursoRating
export function cursoRatingNormalize(row) {
  return {
    idCursoCalificacion: row.idCursoCalificacion ?? row.IdCursoCalificacion ?? row['IdCursoCalificacion'] ?? 0,
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    calificacion: row.calificacion ?? row.Calificacion ?? row['Calificacion'] ?? 0,
    idEstudiante: row.idEstudiante ?? row.IdEstudiante ?? row['IdEstudiante'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
